import React from 'react';
import { useChartStoreConsolidatedMode } from '../../context';
import './fieldSidebar.css';
import CompanyGroupedSidebar from './components/companyGroupedSidebar';
import ConsolidatedSidebar from './components/consolidatedSidebar';

function FieldSidebar() {
    const consolidatedMode = useChartStoreConsolidatedMode();

    return consolidatedMode ? <ConsolidatedSidebar /> : <CompanyGroupedSidebar />;
}

export default React.memo(FieldSidebar);
